import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-marker-icon-school",
  "use": "spr-marker-icon-school-usage",
  "viewBox": "0 0 30 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 30 17\" id=\"spr-marker-icon-school\"><defs><path id=\"spr-marker-icon-school_a\" d=\"M736 290l-6-2v5.72c.54.42 2.57 1.28 6 1.28s5.46-.86 6-1.28V288zm-15-5l15-5 15 5-2 .67V290h-2v-3.67l-3 1V294c0 1.65-3.59 3-8 3s-8-1.35-8-3v-6.67zm6.32 0l8.68 2.9 8.68-2.9-8.68-2.9zm21.68 8h-2v-2h2z\" /></defs><use fill=\"#fff\" xlink:href=\"#spr-marker-icon-school_a\" transform=\"translate(-721 -280)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/marker-icon-school.svg
// module id = 267
// module chunks = 0